import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PersonalFileInfo } from '../../../shared/models/PersonalFileInfo';
//import { ActiveProjectService } from 'src/app/modules/shared/services/activeProject/activeProject.service';
import { AlertService } from '../../../shared/services/alert/Alert.service';
import { FilesService } from '../../services/files/files.service';
import { FilenameRequest } from '../../../shared/models/FilenameRequest';
import { TenantService } from 'projects/shared/src/lib/services/tenant.service';

@Component({
  selector: 'app-file',
  templateUrl: './file.component.html',
  styleUrls: ['./file.component.css']
})
export class FileComponent implements OnInit {
  @Input() isHeader: boolean = false;
  @Input() filesLength: number = 0;

  @Input() file!: PersonalFileInfo;
  @Input() folder!: string;
  @Input() userEmail!: string;

  @Output() onDelete: EventEmitter<PersonalFileInfo> = new EventEmitter();
  @Output() onClick: EventEmitter<PersonalFileInfo> = new EventEmitter();
  @Output() onFirstDownload: EventEmitter<PersonalFileInfo> = new EventEmitter();

  @Output() onAllSelect: EventEmitter<void> = new EventEmitter();
  @Output() onAllDelete: EventEmitter<void> = new EventEmitter();
  @Output() onAllDownload: EventEmitter<void> = new EventEmitter();

  @Input()  selectedFile!: PersonalFileInfo;
  @Input() isMultiselect!: boolean;

  allSelected: boolean = true;

  constructor(private tenantService: TenantService, private AlertService: AlertService,
    // private activeProjectService: ActiveProjectService
  ) { }

  ngOnInit() {
  }

  toggleAllSelect(): void {
    if (!this.isMultiselect || !this.isHeader) return;
    this.allSelected = !this.allSelected;
    this.onAllSelect.emit();
  }

  deleteAllItems(): void {
    if (!this.isMultiselect || !this.isHeader) return;
    this.onAllDelete.emit();
  }

  downloadAllItems(): void {
    if (!this.isMultiselect || !this.isHeader) return;
    this.onAllDownload.emit();
  }

  public onActivate(event: any) {
    if (this.isHeader) return;
    if (event) event.stopPropagation();
    if (this.isMultiselect) {
      this.file.isChecked = !this.file.isChecked;
    } else {
      this.onClick.emit(this.file);
    }
    return;
  }

  public deleteItem(event: any) {
    //if (!this.isHeader) return;
    if (event) event.stopPropagation();
    let self = this;
    // if (self.file.isNew) {
    //   // console.log("-------------> deleteItem: Datei ist neu und wurde noch nicht heruntergeladen!");
    //   self.AlertService.confirm("Datei wurde noch nicht herungergeladen. Löschen? ",
    //     () => {
    //       self.onDelete.emit(self.file);
    //     },
    //     () => {}
    //   );
    // } else
    {
      self.onDelete.emit(self.file);
    }
  }

  public download(event: any = null) {
    if (event) event.stopPropagation();
    let self = this;
    let req = new FilenameRequest();
    req.folder = this.folder;
    req.userEmail = this.userEmail;
    req.filename = this.file.fileName;
    //this.tenantName = (this.tenantService.currentTenantName) ? this.tenantService.currentTenantName : this.tenantName;
    this.tenantService.createPersonalDownloadToken(this.tenantService.currentTenantName, req).subscribe({
      next: (token) => {
        console.log("-------------> token: ", token);
        var fileUrl = this.tenantService.getPersonalFileDownloadUrl(token);
        // self.downloadFile(fileUrl, self.file.fileName);
        self.downloadFile(fileUrl);
        self.onFirstDownload.emit(self.file);
      },
      error: (error: any) => {
        console.log("------> error: ", error.error);
        self.AlertService.setError("Fehler beim Laden der Dateien: " + error.error);
      }
    });
  }

  public downloadFile(fileUrl: string, filename: string = '') {
    console.log("-------------> downloadFile: ", fileUrl, filename);
    const a = document.createElement('a');
    a.href = fileUrl;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
}
